// Utility functions for ChooseTubingForm and related components

export function compare(a, b) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
}

export function getTooltipMessage(option) {
  let tooltipMessage = 'Incompatible with ';
  if (option.incompatible) {
    const translation = {
      shrinkRatio: 'ShrinkRatio',
      diameter: 'Diameter',
      heatshrinkColor: 'Color',
      undefined: 'other selected options'
    };
    for (let i = 0; i < option.incompatible.length - 1; i++) {
      tooltipMessage += `${translation[option.incompatible[i]]}, `;
    }
    tooltipMessage += `${translation[option.incompatible[option.incompatible.length - 1]]}`;
  }
  return tooltipMessage;
}

export function getDisplayValue(type, dataValue, util) {
  if (type == 'diameter' || type == 'length') return util.convertDiameterToText(dataValue);
  else return dataValue;
}
